/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { AppVersionDto } from '../models';
import { DevicesDto } from '../models';
import { GetMenuInfo } from '../models';
import { MyAccount } from '../models';
import { SupportUserDto } from '../models';
import { UpdateBlockedStatusDto } from '../models';
import { UserUpdateProfileDto } from '../models';
/**
 * MyAccountApi - axios parameter creator
 * @export
 */
export const MyAccountApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get user account data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerGetData: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/my-account`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get menu of user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerGetMenu: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/my-account/menu`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get devices access of user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerGetMyDevices: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/my-account/my-devices`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get assigned support user contact info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerGetSupportUserContactInfo: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/my-account/support-user`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get app versions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerGetVersions: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/my-account/versions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Register a support call request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerRegisterSupportCallRequest: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/my-account/support-call-request`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update user account data
     * @param {UserUpdateProfileDto} body User data to update (only safe fields)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerUpdate: async (
      body: UserUpdateProfileDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling myAccountControllerUpdate.'
        );
      }
      const localVarPath = `/my-account`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update organization data of user
     * @param {UpdateBlockedStatusDto} body Organization data blocked status to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerUpdateOrganizationData: async (
      body: UpdateBlockedStatusDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling myAccountControllerUpdateOrganizationData.'
        );
      }
      const localVarPath = `/my-account/organization-data`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update personal data of user
     * @param {UpdateBlockedStatusDto} body User data blocked status to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerUpdatePersonalData: async (
      body: UpdateBlockedStatusDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling myAccountControllerUpdatePersonalData.'
        );
      }
      const localVarPath = `/my-account/personal-data`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update app versions
     * @param {AppVersionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myAccountControllerUpdateVersions: async (
      body: AppVersionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling myAccountControllerUpdateVersions.'
        );
      }
      const localVarPath = `/my-account/versions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MyAccountApi - functional programming interface
 * @export
 */
export const MyAccountApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get user account data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetData(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<MyAccount>>
    > {
      const localVarAxiosArgs =
        await MyAccountApiAxiosParamCreator(
          configuration
        ).myAccountControllerGetData(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get menu of user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetMenu(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<GetMenuInfo>>
    > {
      const localVarAxiosArgs =
        await MyAccountApiAxiosParamCreator(
          configuration
        ).myAccountControllerGetMenu(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get devices access of user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetMyDevices(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<DevicesDto>>
    > {
      const localVarAxiosArgs =
        await MyAccountApiAxiosParamCreator(
          configuration
        ).myAccountControllerGetMyDevices(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get assigned support user contact info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetSupportUserContactInfo(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SupportUserDto>>
    > {
      const localVarAxiosArgs =
        await MyAccountApiAxiosParamCreator(
          configuration
        ).myAccountControllerGetSupportUserContactInfo(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get app versions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetVersions(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<AppVersionDto>>
    > {
      const localVarAxiosArgs =
        await MyAccountApiAxiosParamCreator(
          configuration
        ).myAccountControllerGetVersions(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Register a support call request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerRegisterSupportCallRequest(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs =
        await MyAccountApiAxiosParamCreator(
          configuration
        ).myAccountControllerRegisterSupportCallRequest(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update user account data
     * @param {UserUpdateProfileDto} body User data to update (only safe fields)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerUpdate(
      body: UserUpdateProfileDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(
        configuration
      ).myAccountControllerUpdate(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update organization data of user
     * @param {UpdateBlockedStatusDto} body Organization data blocked status to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerUpdateOrganizationData(
      body: UpdateBlockedStatusDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(
        configuration
      ).myAccountControllerUpdateOrganizationData(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update personal data of user
     * @param {UpdateBlockedStatusDto} body User data blocked status to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerUpdatePersonalData(
      body: UpdateBlockedStatusDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(
        configuration
      ).myAccountControllerUpdatePersonalData(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update app versions
     * @param {AppVersionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerUpdateVersions(
      body: AppVersionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<AppVersionDto>>
    > {
      const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(
        configuration
      ).myAccountControllerUpdateVersions(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * MyAccountApi - factory interface
 * @export
 */
export const MyAccountApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Get user account data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetData(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<MyAccount>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerGetData(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get menu of user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetMenu(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<GetMenuInfo>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerGetMenu(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get devices access of user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetMyDevices(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<DevicesDto>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerGetMyDevices(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get assigned support user contact info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetSupportUserContactInfo(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SupportUserDto>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerGetSupportUserContactInfo(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get app versions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerGetVersions(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<AppVersionDto>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerGetVersions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Register a support call request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerRegisterSupportCallRequest(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerRegisterSupportCallRequest(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update user account data
     * @param {UserUpdateProfileDto} body User data to update (only safe fields)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerUpdate(
      body: UserUpdateProfileDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerUpdate(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update organization data of user
     * @param {UpdateBlockedStatusDto} body Organization data blocked status to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerUpdateOrganizationData(
      body: UpdateBlockedStatusDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerUpdateOrganizationData(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update personal data of user
     * @param {UpdateBlockedStatusDto} body User data blocked status to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerUpdatePersonalData(
      body: UpdateBlockedStatusDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerUpdatePersonalData(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update app versions
     * @param {AppVersionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myAccountControllerUpdateVersions(
      body: AppVersionDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<AppVersionDto>> {
      return MyAccountApiFp(configuration)
        .myAccountControllerUpdateVersions(body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MyAccountApi - object-oriented interface
 * @export
 * @class MyAccountApi
 * @extends {BaseAPI}
 */
export class MyAccountApi extends BaseAPI {
  /**
   *
   * @summary Get user account data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerGetData(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MyAccount>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerGetData(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get menu of user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerGetMenu(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<GetMenuInfo>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerGetMenu(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get devices access of user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerGetMyDevices(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DevicesDto>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerGetMyDevices(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get assigned support user contact info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerGetSupportUserContactInfo(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SupportUserDto>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerGetSupportUserContactInfo(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get app versions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerGetVersions(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<AppVersionDto>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerGetVersions(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Register a support call request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerRegisterSupportCallRequest(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerRegisterSupportCallRequest(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update user account data
   * @param {UserUpdateProfileDto} body User data to update (only safe fields)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerUpdate(
    body: UserUpdateProfileDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerUpdate(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update organization data of user
   * @param {UpdateBlockedStatusDto} body Organization data blocked status to update
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerUpdateOrganizationData(
    body: UpdateBlockedStatusDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerUpdateOrganizationData(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update personal data of user
   * @param {UpdateBlockedStatusDto} body User data blocked status to update
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerUpdatePersonalData(
    body: UpdateBlockedStatusDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerUpdatePersonalData(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update app versions
   * @param {AppVersionDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MyAccountApi
   */
  public async myAccountControllerUpdateVersions(
    body: AppVersionDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<AppVersionDto>> {
    return MyAccountApiFp(this.configuration)
      .myAccountControllerUpdateVersions(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
